export const Overlay = {
    ORIGINAL: "original",
    OLYMPIC: "olympic",
}